import {
	IconBookmarkFilled,
	IconChartColumnFilled,
	IconChatFilled,
	IconFavoriteFilled,
	IconStarFilled,
	IconViewFilled,
} from '@featuring-corp/icons';
import React from 'react';
import CardGroupSection, {
	CardGroupItem,
} from '@components/report/card-group-section/CardGroupSection';
import { useTranslation } from 'react-i18next';

export interface KeyMetricsTtProps {
	averageViews?: string;
	averageLikes?: string;
	averageComments?: string;
	averageShares?: string;
	averageSaves?: string;
	engagementRate?: string;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const KeyMetricsTt = ({
	isLoading,
	isError,
	lackOfPermission,
	...props
}: KeyMetricsTtProps) => {
	const { t } = useTranslation('infReportTiktok');
	const status = { isLoading, isError, lackOfPermission };

	const cardGroup: CardGroupItem[] = [
		{
			label: t('features.report.section-content.tt.key-metrics.average-views.label'),
			tooltip: t('features.report.section-content.tt.key-metrics.average-views.tooltip'),
			icon: IconViewFilled,
			content: props.averageViews,
		},
		{
			label: t('features.report.section-content.tt.key-metrics.average-likes.label'),
			tooltip: t('features.report.section-content.tt.key-metrics.average-likes.tooltip'),
			icon: IconFavoriteFilled,
			content: props.averageLikes,
		},
		{
			label: t('features.report.section-content.tt.key-metrics.average-comments.label'),
			tooltip: t(
				'features.report.section-content.tt.key-metrics.average-comments.tooltip',
			),
			icon: IconChatFilled,
			content: props.averageComments,
		},
		{
			label: t('features.report.section-content.tt.key-metrics.average-shares.label'),
			tooltip: t('features.report.section-content.tt.key-metrics.average-shares.tooltip'),
			icon: IconStarFilled,
			content: props.averageShares,
		},
		{
			label: t('features.report.section-content.tt.key-metrics.average-saves.label'),
			tooltip: t('features.report.section-content.tt.key-metrics.average-saves.tooltip'),
			icon: IconBookmarkFilled,
			content: props.averageSaves,
		},
		{
			label: t('features.report.section-content.tt.key-metrics.engagement-rate.label'),
			tooltip: t(
				'features.report.section-content.tt.key-metrics.engagement-rate.tooltip',
			),
			icon: IconChartColumnFilled,
			content: props.engagementRate,
		},
	];

	return <CardGroupSection cardGroup={cardGroup} {...status} />;
};

export default KeyMetricsTt;
